<template>
  <div class="rules">
    <div v-if="!rules.length" class="rempty">No sub rules — all traffic passes</div>
    <div
      v-for="(r, i) in rules"
      :key="'r' + i + r.sub + r.mode"
      class="rrow"
      :class="{ open: r._open }"
    >
      <div class="rhead">
        <span class="rcar" @click="toggle(r)">▶</span>
        <select class="rsub" :value="r.sub" @change="setSub(r, i, $event.target.value)">
          <option v-for="s in subs" :key="s">{{ s }}</option>
        </select>
        <div class="rmode">
          <button type="button" class="bl" :class="{ on: r.mode !== 'whitelist' }" @click="setMode(r, i, 'blacklist')">BL</button>
          <button type="button" class="wl" :class="{ on: r.mode === 'whitelist' }" @click="setMode(r, i, 'whitelist')">WL</button>
        </div>
        <span class="rcount" :class="{ has: count(r.values) }" @click="toggle(r)">{{ countLabel(r.values) }}</span>
        <span class="rprev" @click="toggle(r)">{{ preview(r.values) }}</span>
        <button type="button" class="rrm" @click="remove(i)">Remove</button>
      </div>
      <div class="rbody">
        <textarea
          class="rta"
          :value="r.values"
          @input="onVals(r, $event.target.value)"
          @blur="format(r)"
        ></textarea>
      </div>
    </div>
    <div class="raddbar">
      <select v-model="addSub">
        <option value="">Sub…</option>
        <option v-for="s in subs" :key="'add'+s">{{ s }}</option>
      </select>
      <label class="ckl"><input type="checkbox" class="cb" v-model="addWl"> Whitelist</label>
      <button type="button" class="btn btn-s primary" @click="add">+ Add rule</button>
      <span class="hint">click a saved rule to edit its sub, mode or values</span>
    </div>
  </div>
</template>

<script>
import { SUB_OPTIONS, SUB_VALUES_LIMIT, normStr, valCount, normVals } from '../../v2/status'

export default {
  name: 'SubRulesEditor',
  props: {
    rules: { type: Array, default: () => [] }
  },
  data() {
    return {
      subs: SUB_OPTIONS,
      addSub: '',
      addWl: false
    }
  },
  methods: {
    count: valCount,
    countLabel(raw) {
      const n = valCount(raw)
      return n + ' value' + (n === 1 ? '' : 's')
    },
    preview(raw) {
      const vals = normVals(raw)
      if (!vals.length) return 'empty — click to add values'
      const head = vals.slice(0, 4).join(', ')
      return vals.length > 4 ? head + ' … +' + (vals.length - 4) : head
    },
    toggle(r) {
      this.$set(r, '_open', !r._open)
    },
    emit() {
      this.$emit('change')
    },
    hasPair(sub, mode, skip) {
      return this.rules.some((r, i) => i !== skip && r.sub === sub && r.mode === mode)
    },
    hasSub(sub, skip) {
      return this.rules.some((r, i) => i !== skip && r.sub === sub)
    },
    setSub(r, i, sub) {
      if (this.hasSub(sub, i)) {
        this.notifyError('A rule for ' + sub + ' already exists — edit it')
        return
      }
      r.sub = sub
      this.emit()
    },
    setMode(r, i, mode) {
      if (this.hasPair(r.sub, mode, i) || this.hasSub(r.sub, i)) {
        this.notifyError('A rule for ' + r.sub + ' already exists — edit it')
        return
      }
      r.mode = mode
      this.emit()
    },
    onVals(r, value) {
      if (value.length > SUB_VALUES_LIMIT) value = value.slice(0, SUB_VALUES_LIMIT)
      r.values = value
      this.emit()
    },
    format(r, toast) {
      const before = r.values || ''
      const after = normStr(before)
      if (before === after) {
        if (toast) this.notifySuccess(valCount(after) + ' values — trimmed, comma separated')
        return
      }
      r.values = after
      this.emit()
      this.notifySuccess(valCount(after) + ' values — trimmed, comma separated')
    },
    remove(i) {
      const r = this.rules[i]
      const n = valCount(r.values)
      if (!window.confirm('Remove ' + r.sub + ' ' + (r.mode === 'whitelist' ? 'whitelist' : 'blacklist') + ' rule (' + n + ' values)?')) return
      this.rules.splice(i, 1)
      this.emit()
    },
    add() {
      if (!this.addSub) {
        this.notifyError('Pick a sub first')
        return
      }
      const mode = this.addWl ? 'whitelist' : 'blacklist'
      if (this.hasSub(this.addSub) || this.hasPair(this.addSub, mode)) {
        this.notifyError('A rule for ' + this.addSub + ' already exists — edit it')
        return
      }
      this.rules.push({ sub: this.addSub, mode, values: '', _open: true })
      this.addSub = ''
      this.addWl = false
      this.emit()
    }
  }
}
</script>
